import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './components/Header'
import Footer from './components/Footer'

import "aos/dist/aos.css"; // Import AOS styles
import Aos from 'aos';
import Blog from './components/Blog';
import Topscroll from './components/Topscroll';
import Aboutus from './components/pages/Aboutus';
import Solutions from './components/pages/Solutions';
import Technologies from './components/pages/Technologies';
import Industries from './components/pages/Industries';
import Careers from './components/pages/Careers';
import Contactus from './components/pages/Contactus';
import UseScrollToTop from './UseScrollToTop';

const App = () => {
  useEffect(() => {
    Aos.init({
      duration: 1000, // Animation duration in ms
      once: true, // Whether animation should happen only once
    });
  }, []);
  return (
    <div>
       <BrowserRouter>
       <UseScrollToTop/>
       <Topscroll/>
        <Header />
        <Routes>
        <Route path="/" element={<Blog />} />
        <Route path="/about-us" element={<Aboutus/>}/>        
        <Route path="/solutions" element={<Solutions/>}/>
        <Route path="/technologies" element={<Technologies/>}/>
        <Route path="/industries" element={<Industries/>}/>
        <Route path="/careers" element={<Careers/>}/>
        <Route path="/contact" element={<Contactus/>}/>
        </Routes>
        <Footer/>
        
      </BrowserRouter>
    </div>
  )
}

export default App